var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_42332)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 98.5979C76.9574 98.5979 98 77.5553 98 51.5979C98 25.6405 76.9574 4.5979 51 4.5979C25.0426 4.5979 4 25.6405 4 51.5979C4 77.5553 25.0426 98.5979 51 98.5979ZM51 102.598C79.1665 102.598 102 79.7644 102 51.5979C102 23.4314 79.1665 0.5979 51 0.5979C22.8335 0.5979 0 23.4314 0 51.5979C0 79.7644 22.8335 102.598 51 102.598Z",
    fill: "#084EBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9405 45.537C58.5261 44.9515 59.4754 44.9515 60.0609 45.537C60.6464 46.1224 60.6464 47.0715 60.0609 47.6569L49.0571 58.6588C48.4716 59.2443 47.5223 59.2443 46.9368 58.6588L41.9391 53.662C41.3536 53.0766 41.3536 52.1275 41.9391 51.5421C42.5246 50.9566 43.4739 50.9566 44.0595 51.5421L47.9969 55.4789L57.9405 45.537Z",
    fill: "#084EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_42332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white",
    transform: "translate(0 0.5979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/success_mark.8d65fbbd7c6414f73bbde0ac3c590bfb.svg";
export { ForwardRef as ReactComponent };